import { render, staticRenderFns } from "./AddPaymentModal.vue?vue&type=template&id=5d08a6d8"
import script from "./AddPaymentModal.vue?vue&type=script&lang=ts"
export * from "./AddPaymentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports